import React from 'react';
import useStyle from './commandeErrorBlock.style';
import { ContainerFullWidth } from 'components/layouts/ContainerFullWidth';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import pages from 'routes/pages';
import { Link } from 'react-router-dom';

interface CommandeErrorBlockProps {
  ExternalUserName?: string;
}

export const CommandeErrorBlock = ({
  ExternalUserName
}: CommandeErrorBlockProps) => {
  const classes = useStyle();
  return (
    <ContainerFullWidth>
      <div className={classes.root}>
        <p className={classes.title}>
          {ExternalUserName ? 'Le' : 'Votre'} carnet de commandes{' '}
          {ExternalUserName && `de ${ExternalUserName}`} est actuellement vide.{' '}
          <span role="img" aria-label="emoji triste">
            😪
          </span>
        </p>
        {!ExternalUserName && (
          <>
            <p>
              Pour saisir une première commande, rendez-vous dans "E-catalogue"
              ou cliquez sur ce bouton :
            </p>
            <Link to={pages.PRODUCTS_PAGE.path}>
              <ButtonWithText
                content="Voir les produits en vente"
                onClick={null}
              />
            </Link>
          </>
        )}
      </div>
    </ContainerFullWidth>
  );
};
